import React from "react"
import Tour from "reactour"
import color from "../../assets/css/colors"
import { ITourComponent } from "./interface"

const TourComponent = ({
    isOpen,
    setStateToClose,
    steps
}: ITourComponent
): React.ReactElement  => {

    return (
        <Tour
            steps={steps}
            isOpen={isOpen}
            onRequestClose={() => setStateToClose(false)} 
            accentColor={color.primary}
            showNumber={false}
            showNavigation
            showNavigationNumber={false}
            showButtons
            startAt={0}
        />
    )
}

export default TourComponent